import styles from "./home.module.scss";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo.svg";
function Home() {
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`${styles.container} flex flex-col justify-center justify-items-center p-4`}
      >
        <div className={`w-full flex justify-center mb-10`}>
          <img src={logo} className="w-52" />
        </div>
        <div
          className={`${styles.card} flex justify-center justify-items-center items-center`}
          onClick={() => {
            navigate("/map");
          }}
        >
          <p className="text-4xl font-bold"> داروخانه‌</p>
        </div>
        <div
          className={`${styles.card} flex justify-center justify-items-center items-center`}
          onClick={() => {
            navigate("/insurance");
          }}
        >
          <p className="text-4xl font-bold">بیمه</p>
        </div>
      </div>
    </>
  );
}

export default Home;
